var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAccordion48Line = function SvgIconAccordion48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6 12.7a1.9 1.9 0 0 0-1.9 1.9v18.8c0 1.05.852 1.9 1.9 1.9h18.8a1.9 1.9 0 0 0 1.9-1.9V14.6a1.9 1.9 0 0 0-1.9-1.9H14.6Zm-5.3 1.9a5.3 5.3 0 0 1 5.3-5.3h18.8a5.3 5.3 0 0 1 5.3 5.3v18.8a5.3 5.3 0 0 1-5.3 5.3H14.6a5.3 5.3 0 0 1-5.3-5.3V14.6Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.92 21.43 24 27.49l4.08-6.06h-8.16Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.42 20.631a1.7 1.7 0 0 1 1.5-.901h8.16a1.7 1.7 0 0 1 1.41 2.65l-4.08 6.06a1.7 1.7 0 0 1-2.82 0l-4.08-6.06a1.7 1.7 0 0 1-.09-1.749Zm4.695 2.499L24 24.446l.886-1.316h-1.772Z",
    fill: "current"
  })));
};
export default SvgIconAccordion48Line;